import axios from 'axios';

/**
 * Laravel registers HTTP routes under the `api` prefix (see bootstrap/app.php).
 * Builds often set VITE_API_URL to the Railway host only — without `/api` the
 * browser hits `/auth/login` and gets 404; CORS preflight then fails.
 */
function normalizeApiBase(raw: string): string {
  let u = raw.trim().replace(/\/+$/, '');
  if (!u.endsWith('/api')) {
    u = `${u}/api`;
  }
  return u;
}

const baseURL = normalizeApiBase(
  import.meta.env.VITE_API_URL ?? 'http://localhost:8080/api',
);

export const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
  },
});

const STORAGE_KEY = 'las-islas-admin-token';

export function setAuthToken(token: string | null): void {
  if (token) {
    localStorage.setItem(STORAGE_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(STORAGE_KEY);
    delete api.defaults.headers.common.Authorization;
  }
}

export function getStoredToken(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

// Auto-redirect on 401
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      setAuthToken(null);
      if (window.location.pathname !== '/login') {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?next=${next}`;
      }
    }
    return Promise.reject(error);
  },
);

// Restore token from storage on module load so subsequent requests carry it
// before Pinia is bootstrapped.
const stored = getStoredToken();
if (stored) {
  api.defaults.headers.common.Authorization = `Bearer ${stored}`;
}
